module.exports = __webpack_public_path__ + "5e133981abc4ecb77f1790576df55108.svg";